import { ComponentProps } from 'react'

const BilPlusIcon: React.FC<React.SVGProps<SVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 1944 1902"
    {...(props as ComponentProps<'svg'>)}
  >
    <circle cx="149.5" cy="793.5" r="149.5" fill="currentColor"></circle>
    <circle cx="149.5" cy="1108.5" r="149.5" fill="currentColor"></circle>
    <circle cx="478.5" cy="793.5" r="149.5" fill="currentColor"></circle>
    <circle cx="478.5" cy="1108.5" r="149.5" fill="currentColor"></circle>
    <circle cx="807.5" cy="793.5" r="149.5" fill="currentColor"></circle>
    <circle cx="807.5" cy="1108.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1136.5" cy="793.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1136.5" cy="1108.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1465.5" cy="793.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1465.5" cy="1108.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1794.5" cy="793.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1794.5" cy="1108.5" r="149.5" fill="currentColor"></circle>
    <circle cx="807.5" cy="149.5" r="149.5" fill="currentColor"></circle>
    <circle cx="807.5" cy="464.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1136.5" cy="149.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1136.5" cy="464.5" r="149.5" fill="currentColor"></circle>
    <circle cx="807.5" cy="1437.5" r="149.5" fill="currentColor"></circle>
    <circle cx="807.5" cy="1752.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1136.5" cy="1437.5" r="149.5" fill="currentColor"></circle>
    <circle cx="1136.5" cy="1752.5" r="149.5" fill="currentColor"></circle>
  </svg>
)

export default BilPlusIcon
